












import Vue from "vue";
import ItemAdminLinks from "@/components/ItemAdminLinks.vue";

export default Vue.extend({
    components: {
        ItemAdminLinks,
    },

    props: {
        item: {
            type: Object,
            default: null
        },
    },

});
